module.exports = __webpack_public_path__ + "static/media/je.2026b139.svg";